/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import { campaignListItemResponseSchema } from '../campaign-schema';

export const endCampaignDatePathSchema = z.object({ campaignId: z.string() });

export const endCampaignDateOperationResponseSchema =
  campaignListItemResponseSchema;

export type EndCampaignDateInput = {
  path: z.input<typeof endCampaignDatePathSchema>;
  signal?: AbortSignal;
};

export async function endCampaignDate({
  path,
  signal,
}: EndCampaignDateInput): Promise<
  z.infer<typeof endCampaignDateOperationResponseSchema>
> {
  const parsedPath = endCampaignDatePathSchema.parse(path);

  const response = await socialApiClient.patch(
    `campaigns/${parsedPath.campaignId}/end`,
    {
      signal,
    },
  );
  return endCampaignDateOperationResponseSchema.parse(await response.json());
}
